import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import { canvasState } from '@components/MainStage/store';

/**
 * Fully exits multi-selection: clears our own selection store and, when a
 * selection was actually active, also drops React Flow's native selection and
 * the single-entity focus dim.
 *
 * Clearing only the Zustand store is not enough — the last shift-clicked node
 * still carries React Flow's native `selected: true`, which leaves a lingering
 * border. The native reset is guarded behind an active selection so callers
 * that fire on unrelated events (e.g. filter changes) never disturb a plain
 * single selection / open drawer when no multi-selection exists.
 */
export const clearMultiSelection = () => {
  const { selectedIds, clear } = getMultiSelectionState();
  const hadSelection = selectedIds.length > 0;

  clear();

  if (!hadSelection) return;

  canvasState().unselectActiveNode();
  canvasState().unselectActiveEdge();
};
